import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        payment: {
          module: () => import('../../../payment/payment.module').then((m) => m.PaymentModule),
          cmsComponents: ['ConfirmPrivateOfferComponent'],
        },
      },
    } as CmsConfig),
  ],
})
export class PaymentFeatureModule {}
